import React, { useContext } from "react";

import classes from "./VolumeForm.module.css";

import CabinetContext from "../../../store/cabinet-context";

import useInput from "../../../hooks/input_hook";

// component for form when adding ingredient to cabinet
const VolumeForm = (props) => {
  const cabinetCtx = useContext(CabinetContext);

  // ensure volument being added is under max volume allowed in cabinet
  const checkVolumeConditions = (volume) => volume > 0 && volume < 9999;

  const {
    value: enteredVolume,
    isValid: enteredVolumeIsValid,
    valueChangeHandler: volumeChangeHandler,
    inputBlurHandler: volumeBlurHandler,
    reset: resetVolumeInput,
    borderColor,
  } = useInput(checkVolumeConditions);

  // add ingredient to cabinet and save to local storage
  const submitHandler = (event) => {
    event.preventDefault();

    if (!enteredVolumeIsValid) {
      return;
    }

    cabinetCtx.addItem({
      ...props.ingredient,
      volume: parseInt(enteredVolume),
    });

    resetVolumeInput();
    props.switchVolumeFormHandler();

    cabinetCtx.saveCabinet();
  };

  return (
    <form className={classes.form} onSubmit={submitHandler}>
 
        <input
          className={classes.input}
          type="number"
          min="1"
          step="1"
          onChange={volumeChangeHandler}
          onBlur={volumeBlurHandler}
          value={enteredVolume}
          style={{ borderColor: ` ${borderColor}` }}
        />
   
      <div>{props.ingredient.unit}</div>
      <div
        disabled={!enteredVolumeIsValid}
        className={classes.submit_button}
        onClick={submitHandler}
      >
        +
      </div>
    </form>
  );
};

export default VolumeForm;
